import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon } from "../../graphic/Icon";
import { PageMessage } from "../../page/PageMessage";
import { Text } from "../../typography/Text";
const msgKey = "noAccessMessage";

export const NoAccessMessage = () => {
    return (
        <PageMessage
            title={<FormattedMessage id={`${msgKey}.title`} />}
            figure={<Icon name="forbidden" size="xLarge" />}
        >
            <Text block size="medium" color="base80">
                <FormattedMessage id={`${msgKey}.message`} />
            </Text>
        </PageMessage>
    );
};
